import { createValidIcon } from './utils/type-helper'

export const AskIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.3736 6.04943C12.1021 5.93384 12.8482 6.02186 13.5299 6.30406C14.2118 6.58631 14.802 7.05178 15.2357 7.6484C15.6696 8.24547 15.9293 8.95046 15.9873 9.68557C16.0453 10.4211 15.8986 11.1584 15.5637 11.8157C15.2289 12.473 14.7193 13.0247 14.0901 13.4102C13.7501 13.6186 13.3825 13.774 13 13.8727V14.0002C13 14.5525 12.5523 15.0002 12 15.0002C11.4477 15.0002 11 14.5525 11 14.0002V12.9998C11 12.4475 11.4477 11.9998 12 11.9998C12.3689 11.9998 12.7306 11.8978 13.0451 11.705C13.3595 11.5123 13.6141 11.2367 13.7816 10.9079C13.9491 10.5791 14.0224 10.2104 13.9935 9.84275C13.9644 9.47466 13.8345 9.12235 13.6178 8.82426C13.4009 8.52571 13.1056 8.293 12.765 8.15199C12.4242 8.01093 12.0514 7.96691 11.687 8.02472C11.3225 8.08256 10.9807 8.24016 10.7005 8.47969C10.4199 8.71944 10.2115 9.03158 10.0977 9.38229C9.92717 9.90761 9.36312 10.1953 8.8378 10.0248C8.31249 9.8543 8.02484 9.29025 8.19532 8.76493C8.42309 8.06307 8.84037 7.43848 9.4011 6.95928C9.96208 6.47985 10.6451 6.165 11.3736 6.04943ZM10.9502 17C10.9502 16.4477 11.3979 16 11.9502 16H12.0498C12.6021 16 13.0498 16.4477 13.0498 17V17.1C13.0498 17.6515 12.6033 18.0989 12.0518 18.1L11.9521 18.1002C11.6866 18.1007 11.4317 17.9956 11.2438 17.808C11.0558 17.6204 10.9502 17.3658 10.9502 17.1002V17Z'
        fill={color}
      />
    </svg>
  )
})
